import React from 'react';

import { ReactComponent as ChevronIcon } from 'assets/chevron-right.svg';

import RowContent, { RowContentProps } from '../RowContent/RowContent';

import styles from './LinkRow.module.scss';

interface LinkRowProps extends RowContentProps, React.ComponentPropsWithoutRef<'a'> {}

const LinkRow: React.FC<LinkRowProps> = ({ icon, text, ...props }) => (
  <a className={styles.linkRow} {...props}>
    <RowContent icon={icon} text={text}></RowContent>
    <ChevronIcon className={styles.chevron} />
  </a>
);

export default LinkRow;
